import { EntityTypeOld, ErrorStateOld } from "../interfaces/products";

import {
  AkaCartAdviceValues,
  CartAdviceValues,
} from "Components/Features/CheckPrice/Products/Advice/ProductDetails/FormElements/interfaces";
import { HuseierneMembershipStatus } from "Components/Form/Partner/partnerFormValuesInterfaces";
import { PaymentPeriod } from "Constants/constants";
import { InsuranceProduct } from "../interfaces/products/checkout";

export interface Cart {
  readonly cartId: string;
  readonly orderId: string;
  readonly confirmationStatus?: string;
  readonly products: InsuranceProduct[];
  readonly customer: Customer;
  readonly agreementProduct?: number;
  readonly containsLifeInsurancesOnly?: boolean;
  readonly label: string;
  readonly cartSaved: boolean;
  readonly cartOwnedByAdvisor?: boolean;
  readonly cartUpdatedWithNewPrice: boolean;
  readonly advice?: CartAdviceValues | AkaCartAdviceValues;
  readonly offerInfo?: {
    readonly status?: OfferStatus;
    readonly advisorComment?: string;
    readonly advisorAffiliation?: AdvisorAffiliation;
    readonly offerAcceptDocumentId?: string;
    readonly orderCommitRole?: OrderCommitRole;
  };
  readonly uwStatus: UWStatus;
}

export interface Customer {
  readonly customerId: string;
  readonly firstName?: string;
  readonly lastName?: string;
  readonly age?: number;
  readonly dateOfBirth?: string;
  readonly email?: string;
  readonly mobilePhone?: string;
  readonly providedEmail?: string;
  readonly providedMobilePhone?: string;
  readonly chosenPaymentPeriod?: PaymentPeriod;
  readonly consents?: Consents;
  readonly shouldDoCreditCheck?: boolean;
  readonly partnerCustomerInfo?: PartnerCustomerInfo;
  readonly salesPersonInfo?: {
    readonly name: { firstName: string; lastName: string };
  };
}

export interface Consents {
  readonly hasAcceptedElectronicCustomer?: boolean;
  readonly hasAcceptedAdvertisingOnEmail?: boolean;
  readonly hasAcceptedAdvertisingOnSms?: boolean;
  readonly hasAcceptedElectronicReceiptForCreditScoreCheck?: boolean;
  readonly hasAcceptedEnterprise?: boolean;
  readonly hasAcceptedHuseierneCreateMembership?: boolean;
  readonly hasAcceptedHuseierneCommunicationAndInformationTransfer?: boolean;
}

export type CartEntity = EntityTypeOld<Cart, OperationType>;

export enum OperationType {
  FETCH_CART = "FETCH_CART",
  UPDATE_CART = "UPDATE_CART",
  CREATE_ORDER = "CREATE_ORDER",
  VALIDATE_ORDER = "VALIDATE_ORDER",
  COMMIT_ORDER = "COMMIT_ORDER",
  UPDATE_PRODUCT = "UPDATE_PRODUCT",
  UPDATE_PRODUCT_IN_STORE_ONLY = "UPDATE_PRODUCT_IN_STORE_ONLY",
  REMOVE_PRODUCT = "REMOVE_PRODUCT",
}

export enum ConfirmationStatus {
  NOT_CONFIRMED = "NOT_CONFIRMED",
  CART_IS_CONFIRMED = "CART_IS_CONFIRMED",
}

export enum OfferStatus {
  NOT_SENT = "NOT_SENT",
  SENT = "SENT",
  ACCEPTED = "ACCEPTED",
}

export enum AdvisorAffiliation {
  ARAMIS_AS = "ARAMIS_AS",
  DIN_SALGSKONSULENT = "DIN_SALGSKONSULENT",
  EXITO_ASSURANSE_AS = "EXITO_ASSURANSE_AS",
  FRONT_FORSIKRING_AS = "FRONT_FORSIKRING_AS",
  II_TRUST_AS = "II_TRUST_AS",
  LOYALTY_CUSTOMER_SERVICE_AS = "LOYALTY_CUSTOMER_SERVICE_AS",
  MYRE_PARNTERE_AS = "MYRE_PARTNERE_AS",
  OSTFOLD_FORSIKRING_AS = "OSTFOLD_FORSIKRING_AS",
  STOREBRAND_BANKTEAM = "STOREBRAND_BANKTEAM",
  STOREBRAND_FORSIKRINGSTEAM = "STOREBRAND_FORSIKRINGSTEAM",
  SEGURO_FORSIKRING_AS = "SEGURO_FORSIKRING_AS",
  UNION_FORSIKRING_AS = "UNION_FORSIKRING_AS",
  DANSKE_BANK = "DANSKE_BANK",
  // Coop and Akademikerne are not to be used yet
  // FORSIKRINGSTEAM_COOP = 'FORSIKRINGSTEAM_COOP',
  // FORSIKRINGSTEAM_AKADEMIKERNE = 'FORSIKRINGSTEAM_AKADEMIKERNE',
}

export enum OrderCommitRole {
  CUSTOMER = "CUSTOMER",
  ADVISOR = "ADVISOR",
}

export interface AcceptOrder {
  cartId: string;
  email: string;
  phone: string;
}

export interface AcceptAndSendOrder {
  cartId: string;
  customer: Customer;
}

export interface AcceptAndValidateOrder {
  cartId: string;
  orderId: string;
}

export type CartError = ErrorStateOld<OperationType>;

export interface FetchCart {
  cartId: string;
  forceRecalculate?: boolean;
}

export interface CoopMembership {
  id: string;
  name: string;
}

export interface PartnerCustomerInfo {
  coopCustomerId?: string;
  coopPhone?: string;
  coopMemberships?: CoopMembership[];
  coopSelectedMembership?: CoopMembership;
  huseierneMembershipStatus?: HuseierneMembershipStatus;
  isHuseierneMemberConfirmation?: boolean;
}

export enum UWStatus {
  DEFAULT = "DEFAULT",
  HAS_ERRORS = "HAS_ERRORS",
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}
